import { Skeleton } from '@mui/material';
import { styled } from '@mui/material/styles';

export const ResponsiveSkeleton = styled(Skeleton, {
  shouldForwardProp: (prop) => prop !== 'customWidth',
})<{ customWidth: string }>(({ customWidth }) => ({
  width: `min(100%, ${customWidth})`,
}));
